(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDeviceReleasesDetailController', TabDeviceReleasesDetailController);

    TabDeviceReleasesDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function TabDeviceReleasesDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.tabDeviceReleases = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabDeviceReleasesUpdate', function(event, result) {
            vm.tabDeviceReleases = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
